import { Navigate, useParams } from "react-router-dom";
import { findService } from "../../data/services";
import ServicePage from "./ServicePage";

export default function ServiceDetail() {
  const { slug } = useParams();
  const service = findService(slug);

  if (!service) return <Navigate to="/" replace />;

  return (
    <ServicePage
      eyebrow="Our Services"
      title={service.label}
      subtitle={service.subtitle}
      slug={service.slug}
      sections={service.sections}
      features={service.features}
    />
  );
}
